/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { getBrowserLanguage } from "../../i18n/translations";

const getInitialLanguage = () => {
  const saved = localStorage.getItem("language");
  if (saved) return saved;
  return getBrowserLanguage();
};

const initialStateValue = {
  selected: getInitialLanguage(),
};

export const languageSlice = createSlice({
  name: "language",
  initialState: { value: initialStateValue },
  reducers: {
    setLanguage: (state, action) => {
      state.value = { ...state.value, ...action.payload };
      localStorage.setItem("language", action.payload.selected);
    },

    resetLanguage: (state) => {
      state.value = initialStateValue;
    },
  },
});

export const { setLanguage, resetLanguage } = languageSlice.actions;

export default languageSlice.reducer;
